import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selectors } from './../../../../../../shared/ducks/customer.duck';
import OrganisationDeleteForm from './../../../../../shared/containers/OrganisationDeleteForm';

const getInitialValues = createSelector(
  selectors.data,
  R.applySpec({
    customerId: R.prop('id'),
  }),
);

const OrganisationCustomerDeleteForm = connect(state => ({
  initialValues: getInitialValues(state),
}))(OrganisationDeleteForm);

export default OrganisationCustomerDeleteForm;
